var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { ModuleValueGeneral, SchemaModuleGeneral } from './module-general';
import * as rawJSONSchemaModuleGynaecology from '../../schemas/module-gynaecology.json';
var ModuleValueGynaecology = (function (_super) {
    __extends(ModuleValueGynaecology, _super);
    function ModuleValueGynaecology() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return ModuleValueGynaecology;
}(ModuleValueGeneral));
var SchemaModuleGynaecology = (function (_super) {
    __extends(SchemaModuleGynaecology, _super);
    function SchemaModuleGynaecology() {
        var _this = _super.call(this) || this;
        _this.loadSchema(rawJSONSchemaModuleGynaecology);
        return _this;
    }
    SchemaModuleGynaecology.prototype.hook = function (form) {
        _super.prototype.hook.call(this, form);
        this.listenValue(['discharge_date_hysterectomy', 'date_of_surgery'], this.fieldHandlerDischargeDate('length_of_stay_hysterectomy').bind(this));
        this.listenValue(['discharge_date_pelvic', 'date_of_surgery'], this.fieldHandlerDischargeDate('length_of_stay_pelvic').bind(this));
        this.listenValue(['discharge_date_resection', 'date_of_surgery'], this.fieldHandlerDischargeDate('length_of_stay_resection').bind(this));
        this.listenValue(['discharge_date_minor', 'date_of_surgery'], this.fieldHandlerDischargeDate('length_of_stay_minor').bind(this));
        this.listenValue(['discharge_date_salpingo', 'date_of_surgery'], this.fieldHandlerDischargeDate('length_of_stay_salpingo').bind(this));
        this.listenValue(['discharge_date_myomectomy', 'date_of_surgery'], this.fieldHandlerDischargeDate('length_of_stay_myomectomy').bind(this));
        this.listenValue(['discharge_date_vulval', 'date_of_surgery'], this.fieldHandlerDischargeDate('length_of_stay_vulval').bind(this));
        this.listenValue([
            'main_procedure',
            'primary_surgical_approach_hysterectomy',
            'pre_existing_comorbidities',
            'date_of_surgery',
            'date_of_birth',
            'asa',
        ], this.fieldHandlerCalculateHysterectomyRiskIndicator.bind(this));
        this.listenValue([
            'ics_enabled',
            'ics_category__mesh_removal',
            'ics_division_cat1__mesh_removal',
            'ics_division_cat2__mesh_removal',
            'ics_division_cat4__mesh_removal',
            'ics_division_cat5__mesh_removal',
            'ics_division_cat6__mesh_removal',
            'ics_division_cat7__mesh_removal',
            'ics_pain_cat1__mesh_removal',
            'ics_pain_cat1_readonly__mesh_removal',
            'ics_pain_cat2__mesh_removal',
            'ics_pain_cat2_readonly__mesh_removal',
            'ics_pain_cat4__mesh_removal',
            'ics_pain_cat5__mesh_removal',
            'ics_pain_cat6__mesh_removal',
            'ics_pain_cat7__mesh_removal',
            'ics_time__mesh_removal',
            'ics_site__mesh_removal',
            'ics_site_cat7__mesh_removal',
        ], this.fieldHandlerCalculateICSCode.bind(this));
    };
    SchemaModuleGynaecology.prototype.setupValidators = function () {
        _super.prototype.setupValidators.call(this);
        this.validatorDateComparison('date_of_diagnosis', 'date_of_birth', '>');
        this.validatorDateComparison('date_of_surgery', 'date_of_birth', '>');
        this.validatorDateComparison('date_of_surgery', 'date_of_diagnosis', '>=');
        this.validatorDateComparison('discharge_date_hysterectomy', 'date_of_birth', '>');
        this.validatorDateComparison('discharge_date_hysterectomy', 'date_of_surgery', '>=');
        this.validatorDateComparison('discharge_date_pelvic', 'date_of_birth', '>');
        this.validatorDateComparison('discharge_date_pelvic', 'date_of_surgery', '>=');
        this.validatorDateComparison('discharge_date_resection', 'date_of_birth', '>');
        this.validatorDateComparison('discharge_date_resection', 'date_of_surgery', '>=');
        this.validatorDateComparison('discharge_date_minor', 'date_of_birth', '>');
        this.validatorDateComparison('discharge_date_minor', 'date_of_surgery', '>=');
        this.validatorDate('date_of_birth', (new Date()), '<=', function (v) { return new Date(v); });
        this.validatorDate('date_of_diagnosis', (new Date()), '<=', function (v) { return new Date(v); });
    };
    SchemaModuleGynaecology.prototype.fieldHandlerCalculateHysterectomyRiskIndicator = function (main_procedure, approach, comorbs, dateOfSurgery, dateOfBirth, asa) {
        if (!main_procedure || !approach || !comorbs || !dateOfSurgery || !dateOfBirth || !asa || main_procedure !== 'hysterectomy') {
            this.updateValue('risk_indicator_hysterectomy', '');
            return;
        }
        var abdominal = ['abdominal', 'conversion_to_laparotomy'].indexOf(approach) != -1;
        var charlsonWeights = {
            // Weight 1
            myocardial: 1,
            congestive_heart_failure: 1,
            peripheral_vascular_disease: 1,
            dementia: 1,
            cerebrovascular_disease: 1,
            chronic_pulmonary_disease: 1,
            connective_tissue_disease: 1,
            // ulcer
            mild_liver_disease: 1,
            diabetes_mellitus: 1,
            // Weight 2
            hemiplegia: 2,
            moderate_or_severe_renal_disease: 2,
            diabetes_mellitus_with_end_organ_damage: 2,
            any_tumour: 2,
            leukaemia: 2,
            lymphoma: 2,
            // Weight 3
            moderate_or_severe_liver_disease: 3,
            // Weight 6
            // malignant tumor
            metastic_cancer: 6,
            aids: 6,
            // Other
            gord: 0,
            incomplete: 0,
            none: 0,
        };
        var charlson = (comorbs).reduce(function (total, comorb) {
            var weight = charlsonWeights[comorb];
            if (!isNaN(weight)) {
                total += weight;
            }
            return total;
        }, 0);
        var dob = new Date(dateOfBirth);
        var dos = new Date(dateOfSurgery);
        var age = Math.floor((dos.valueOf() - dob.valueOf()) / 1000 / 60 / 60 / 24 / 365.25);
        var asa2 = [
            '2_mild_systemic_disease',
            '3_severe_systemic_disease',
            '4_life_threatening',
            '5_moribund',
            '6_brain_dead',
        ].indexOf(asa) != -1;
        var score = -3.209;
        score += abdominal ? 0.723 : 0;
        score += charlson >= 2 ? 0.820 : 0;
        score += !isNaN(age) && age > 0 && age < 50 ? 0.314 : 0;
        score += !isNaN(age) && age >= 60 ? -0.454 : 0;
        score += asa2 ? 0.277 : 0;
        var outcomeProb = (Math.pow(Math.E, score)) * 100;
        this.updateValue('risk_indicator_hysterectomy', outcomeProb.toFixed(2));
    };
    SchemaModuleGynaecology.prototype.fieldHandlerCalculateICSCode = function (ics_enabled, category, division_cat1, division_cat2, division_cat4, division_cat5, division_cat6, division_cat7, pain_cat1, pain_cat1_readonly, pain_cat2, pain_cat2_readonly, pain_cat4, pain_cat5, pain_cat6, pain_cat7, time, site, site_cat7) {
        // If ICS is not enabled, clear the code
        if (!ics_enabled || !category) {
            this.updateValue('ics_code', '');
            return;
        }
        // Get the appropriate division and pain based on category
        var division = '';
        var pain = '';
        switch (category) {
            case '1':
                division = division_cat1 || '';
                pain = (division === 'A' ? 'a' : pain_cat1) || '';
                break;
            case '2':
            case '3':
                division = division_cat2 || '';
                pain = (division === 'A' ? 'a' : pain_cat2) || '';
                break;
            case '4':
                division = division_cat4 || '';
                pain = pain_cat4 || '';
                break;
            case '5':
                division = division_cat5 || '';
                pain = pain_cat5 || '';
                break;
            case '6':
                division = division_cat6 || '';
                pain = pain_cat6 || '';
                break;
            case '7':
                division = division_cat7 || '';
                pain = pain_cat7 || '';
                break;
        }
        // Build the ICS code: CategoryDivisionpainTimeSite (no dashes)
        // If any field is not selected or "unspecified", use a space " " instead
        var code = '';
        // Category is always added if present
        if (category) {
            code += category;
        }
        // Division: space if empty or unspecified
        if (!division || division === 'unspecified') {
            code += ' ';
        }
        else {
            code += division;
        }
        // Pain: space if empty or unspecified
        if (!pain || pain === 'unspecified') {
            code += ' ';
        }
        else {
            code += pain;
        }
        // Time: space if empty or unspecified
        if (!time || time === 'unspecified') {
            code += ' ';
        }
        else {
            code += time;
        }
        // Site: Use site_cat7 when category is 7 and division is B or C, otherwise use site
        var siteValue = site;
        if (category === '7' && division && ['B', 'C'].indexOf(division) !== -1) {
            // For category 7 with division B or C, use site_cat7
            // Extract just the site code (e.g., "S0" from "S0 - No site applicable")
            if (site_cat7) {
                siteValue = site_cat7.split(' ')[0]; // Extract "S0" from "S0 - No site applicable"
            }
            else {
                siteValue = '';
            }
        }
        // Site: space if empty or unspecified
        if (!siteValue || siteValue === 'unspecified') {
            code += ' ';
        }
        else {
            code += siteValue;
        }
        // Format: CategoryDivisionpainTimeSite (e.g., 2BcT2S2 or 2B   S2 if some fields not selected)
        this.updateValue('ics_code', code);
    };
    return SchemaModuleGynaecology;
}(SchemaModuleGeneral));
export { SchemaModuleGynaecology };



// WEBPACK FOOTER //
// /var/www/schemas-forms/src/app/forms/module-gynaecology.ts.pre-build-optimizer.js